module.exports = __webpack_public_path__ + "static/media/schuettler_mit_active.cd833ef6.jpg";